import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MaterialModule, SpinnerLoaderComponent, ErrorComponent,MemberModificationErrorHandlerComponent } from '@core';;
import { MainModule } from './main/main.module';
import { _HTTPInterceptorsProviders } from './interceptors';
import { SharedModule } from '@shared';
import { ManagementModule } from '@management';
import { OverlayModule } from '@angular/cdk/overlay';
import { environment } from 'src/environments/environment.uat';
import { APP_VERSION } from './core/injection-tokens/app-version.token';

@NgModule({
  declarations: [
    AppComponent,
    SpinnerLoaderComponent,
    ErrorComponent,
    MemberModificationErrorHandlerComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    MainModule,
    SharedModule,
    ManagementModule,
    OverlayModule
  ],
  providers: [
    _HTTPInterceptorsProviders,
    { provide: LOCALE_ID, useValue: 'en-US' },
    provideHttpClient(withInterceptorsFromDi()),
    { provide: APP_VERSION, useValue: `${environment.appVersion}` },
  ],
})
export class AppModule {}
